import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { useState } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFormRegion } from 'system/geographic/pages/region/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersConsulateProps {
  filterRegionForm: FormikProps<FiltersFormRegion>;
}

const FiltersRegion = ({ filterRegionForm }: FiltersConsulateProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-consulate-content"
        id="panel-consulate-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterRegionForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Codice regione"
                label="Codice"
                id="code"
                name="code"
                fullWidth
                onBlur={filterRegionForm.handleBlur}
                type="text"
                variant="outlined"
                inputProps={{
                  maxLength: '3',
                  pattern: '[0-9]*',
                }}
                value={filterRegionForm.values.code}
                onChange={(event) =>
                  filterRegionForm.setFieldValue(
                    'code',
                    event.target.validity.valid ? event.target.value : filterRegionForm.values.code
                  )
                }
                error={filterRegionForm.touched.code && Boolean(filterRegionForm.errors.code)}
                helperText={filterRegionForm.errors.code}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Nome regione"
                label="Nome regione"
                id="name"
                name="name"
                fullWidth
                onBlur={filterRegionForm.handleBlur}
                type="text"
                inputProps={{
                  maxLength: '24',
                }}
                variant="outlined"
                value={filterRegionForm.values.name}
                onChange={(event) => {
                  filterRegionForm.setFieldValue('name', event.target.value);
                }}
                error={filterRegionForm.touched.name && Boolean(filterRegionForm.errors.name)}
                helperText={filterRegionForm.errors.name}
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterRegionForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersRegion.displayName = 'Filters region component';

export default FiltersRegion;
